import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { CardHoldersProvider } from './team.context'

function Teams({ role }) {
  const navigate = useNavigate()
  return (
    <CardHoldersProvider>
      <div class='tw-inline-block tw-mb-4 tw-w-fit'>
        <span onClick={() => navigate(-1)} class='tw-cursor-pointer'>← back</span>
      </div>
      <Outlet />
    </CardHoldersProvider>
  )
}

export default Teams
